import React, { Fragment } from 'react';
import { bool, instanceOf, func, string } from 'prop-types';
import { connect } from 'react-redux';

import DictionaryBox from './DictionaryBox';
import SurveyNameForm from '../SurveyNameForm';
import {
  saveSurveyDictionary,
  handleCreateSurvey,
} from '../../../actions/turnkeyOmnibusActions';

const Dictionary = ({
  handleBack,
  handleNext,
  surveyName,
  error,
  invalid,
  saveSurveyDictionary,
  handleCreateSurvey,
  oldSurveyName,
}) => {
  const validate = a => {
    const re = /^[a-zA-Z0-9 ]*$/;
    return re.test(a);
  };

  const _isButtonEnable = () => {
    const isValid = validate(surveyName.trim());
    const speicalCharError = invalid.specialChar.length > 0;
    const maxLengthError = invalid.maxLength.length > 0;
    const isDisaled =
      surveyName && isValid && !error && (!speicalCharError && !maxLengthError);
    return !isDisaled;
  };

  const _saveDictionary = () => {
    saveSurveyDictionary().then(res => {
      if (res) {
        handleNext();
      }
    });
  };

  const _hanldeNextclick = () => {
    if (oldSurveyName !== surveyName) {
      handleCreateSurvey().then(res => {
        if (res) {
          _saveDictionary();
        }
      });
    } else {
      _saveDictionary();
    }
  };

  return (
    <Fragment>
      <div className="ie--steps--body ie--dictionary">
        <SurveyNameForm />
        <DictionaryBox />
      </div>
      <footer className="ie--steps--footer">
        <button
          type="button"
          className="ie--button ie--button-sm"
          onClick={handleBack}
        >
          Back
        </button>
        <button
          type="button"
          className="ie--button ie--button-sm"
          onClick={_hanldeNextclick}
          disabled={_isButtonEnable()}
        >
          Save &amp; Continue
        </button>
      </footer>
    </Fragment>
  );
};

Dictionary.propTypes = {
  handleNext: func.isRequired,
  handleBack: func.isRequired,
  saveSurveyDictionary: func.isRequired,
  handleCreateSurvey: func.isRequired,
  surveyName: string,
  oldSurveyName: string,
  error: bool,
  invalid: instanceOf(Object),
};

Dictionary.defaultProps = {
  error: false,
  invalid: {
    specialChar: [],
    maxLength: [],
  },
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { surveyQnO, surveyInfo, ieSurvey } = turnkeyOmnibus;
  return {
    surveyName: surveyInfo.surveyName,
    error: surveyQnO.error,
    invalid: surveyQnO.invalid,
    oldSurveyName: ieSurvey.data.surveyName,
  };
};

export default connect(
  mapStateToProps,
  { saveSurveyDictionary, handleCreateSurvey }
)(Dictionary);
